export const LAYOUT_TYPE = {
  dashboard_desktop_card: 'dashboard_desktop_card',
  investing_slider_card: 'investing_slider_card',
  investing_offer_card: 'investing_offer_card',
};
